import { render, staticRenderFns } from "./ButtonReload.vue?vue&type=template&id=0bf906d2&scoped=true"
import script from "./ButtonReload.vue?vue&type=script&lang=ts"
export * from "./ButtonReload.vue?vue&type=script&lang=ts"
import style0 from "./ButtonReload.vue?vue&type=style&index=0&id=0bf906d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf906d2",
  null
  
)

export default component.exports